import { render, staticRenderFns } from "./universal.vue?vue&type=template&id=4f21336c&scoped=true&"
import script from "./universal.vue?vue&type=script&lang=js&"
export * from "./universal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21336c",
  null
  
)

export default component.exports